export const FETCH_CONNECTIONS_SUCCESS = 'FETCH_CONNECTIONS_SUCCESS';
export const FETCHING_CONNECTIONS = 'FETCHING_CONNECTIONS';
export const CREATING_CONNECTION = 'CREATING_CONNECTION';
export const CREATE_CONNECTION_SUCCESS = 'CREATE_CONNECTION_SUCCESS';
export const CREATE_CONNECTION_FAILURE = 'CREATE_CONNECTION_FAILURE';
export const FETCH_CONNECTION = 'FETCH_CONNECTION';
export const FETCH_CONNECTION_SUCCESS = 'FETCH_CONNECTION_SUCCESS';
export const FETCHING_CONNECTION = 'FETCHING_CONNECTION';
export const UPDATE_CONNECTION_SUCCESS = 'UPDATE_CONNECTION_SUCCESS';
export const UPDATING_CONNECTION = 'UPDATING_CONNECTION';
export const CHECKING_CONNECTION = 'CHECKING_CONNECTION';
export const CHECKING_CONNECTION_SUCCESS = 'CHECKING_CONNECTION_SUCCESS';
export const CONNECTION_SUCCESS = 'Connection Success';
export const CONNECTION_FAILED = 'Connection Failed';
export const RESET_FIELDS = "RESET_FIELDS";



// WEBPACK FOOTER //
// ./src/redux/connections/ConnectionsConstants.js